import { Button, Modal, Popover } from "antd";
import React from "react";
import { CopyIcon2 } from "../Icons/CopyIcon";
import { ShareIcon } from "../Icons/ShareIcon";
import { QRIcon } from "../Icons/QRIcon";
import { useApp } from "../../contexts";
import { Copy } from "../Copy";
import { useRef } from "react";
import QRCode from "react-qr-code";
import { useState } from "react";
import styled from "styled-components";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { useWindowSize } from "../../hook/useWindowSize";
export const ButtonShareGroup = styled.div`
  & .btn-item {
    transition: all 0.5s ease;
    cursor: pointer;
    &:hover {
      transform: rotateZ(20deg);
    }
  }
`;

export const Textdetail = styled.span`
  color: #000;
  text-align: center;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 33.6px; /* 210% */
`;

const content = (value) => (
  <ButtonShareGroup className="flex gap-3">
    <FacebookShareButton url={value}>
      <div className="btn-item">
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 7.16536C9.11599 7.16536 8.26814 7.51655 7.64302 8.14168C7.01789 8.7668 6.66671 9.61465 6.66671 10.4987V30.4987C6.66671 31.3827 7.01789 32.2305 7.64302 32.8557C8.26814 33.4809 9.11599 33.832 10 33.832H30C30.884 33.832 31.7319 33.4809 32.357 32.8557C32.9822 32.2305 33.3334 31.3827 33.3334 30.4987V10.4987C33.3334 9.61465 32.9822 8.7668 32.357 8.14168C31.7319 7.51655 30.884 7.16536 30 7.16536H10ZM10 3.83203H30C31.7682 3.83203 33.4639 4.53441 34.714 5.78465C35.9644 7.0349 36.6667 8.73058 36.6667 10.4987V30.4987C36.6667 32.2669 35.9644 33.9625 34.714 35.2127C33.4639 36.463 31.7682 37.1654 30 37.1654H10C8.23192 37.1654 6.53624 36.463 5.28599 35.2127C4.03576 33.9625 3.33337 32.2669 3.33337 30.4987V10.4987C3.33337 8.73058 4.03576 7.0349 5.28599 5.78465C6.53624 4.53441 8.23192 3.83203 10 3.83203Z"
            fill="black"
          />
          <path
            d="M18.3333 26.312V34.6454H21.6667V26.312H25L25.8333 22.9787H21.6667V20.2204C21.6667 18.6904 21.74 18.317 21.94 17.9404C22.0557 17.7157 22.2385 17.5327 22.4633 17.417C22.84 17.2154 23.4717 17.1437 25 17.1437H25.835V13.9771C24.9633 13.8521 24.2533 13.8087 23.705 13.8437C22.3217 13.9321 21.53 14.1371 20.8933 14.4787C20.0867 14.9049 19.4268 15.564 19 16.3704C18.5667 17.1854 18.3333 17.9937 18.3333 20.222V22.9787H15V26.312H18.3333Z"
            fill="black"
          />
        </svg>
      </div>
    </FacebookShareButton>
    <TwitterShareButton url={value}>
      <div className="btn-item">
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4921 7.16536C9.60806 7.16536 8.76021 7.51655 8.13509 8.14168C7.50996 8.7668 7.15877 9.61465 7.15877 10.4987V30.4987C7.15877 31.3827 7.50996 32.2305 8.13509 32.8557C8.76021 33.4809 9.60806 33.832 10.4921 33.832H30.4921C31.3761 33.832 32.2239 33.4809 32.8491 32.8557C33.4743 32.2305 33.8254 31.3827 33.8254 30.4987V10.4987C33.8254 9.61465 33.4743 8.7668 32.8491 8.14168C32.2239 7.51655 31.3761 7.16536 30.4921 7.16536H10.4921ZM10.4921 3.83203H30.4921C32.2603 3.83203 33.9559 4.53441 35.2061 5.78465C36.4564 7.0349 37.1588 8.73058 37.1588 10.4987V30.4987C37.1588 32.2669 36.4564 33.9625 35.2061 35.2127C33.9559 36.463 32.2603 37.1654 30.4921 37.1654H10.4921C8.72399 37.1654 7.02831 36.463 5.77806 35.2127C4.52782 33.9625 3.82544 32.2669 3.82544 30.4987V10.4987C3.82544 8.73058 4.52782 7.0349 5.77806 5.78465C7.02831 4.53441 8.72399 3.83203 10.4921 3.83203Z"
            fill="black"
          />
          <path
            d="M27.1916 15.6472C27.9772 15.165 28.4974 14.5068 28.7521 13.6697C28.0346 14.0577 27.2647 14.3397 26.4664 14.5068C25.7829 13.7718 24.9176 13.3984 23.8802 13.3984C22.8662 13.3984 22.0097 13.7543 21.3107 14.4465C20.9731 14.7752 20.7062 15.1694 20.5262 15.6049C20.3464 16.0404 20.2574 16.508 20.2646 16.9791C20.2646 17.2796 20.3024 17.5479 20.3782 17.7754C17.3877 17.6734 14.9125 16.4328 12.9622 14.045C12.6316 14.6293 12.4664 15.2243 12.4664 15.8397C12.4664 17.1046 13.0001 18.1069 14.0657 18.8429C13.458 18.7914 12.9223 18.6377 12.4664 18.3859C12.4664 19.2892 12.7318 20.0436 13.2636 20.7076C13.7802 21.3547 14.5082 21.7991 15.3198 21.9627C15.0165 22.0406 14.6966 22.0776 14.368 22.0776C14.0647 22.0776 13.8498 22.0522 13.7225 21.9967C13.9461 22.7327 14.368 23.3297 14.9776 23.7867C15.5802 24.2442 16.3133 24.4972 17.0698 24.5091C15.7748 25.5251 14.2941 26.0276 12.619 26.0276C12.2087 26.0276 11.918 26.0217 11.7421 25.9907C13.3919 27.0621 15.2284 27.5939 17.2604 27.5939C19.3399 27.5939 21.1776 27.0669 22.7767 26.0131C24.3761 24.9651 25.5564 23.6719 26.3147 22.1494C27.0646 20.6762 27.4551 19.0464 27.4541 17.3934V16.9383C28.1531 16.423 28.7582 15.7912 29.2431 15.0707C28.5884 15.3544 27.8982 15.5484 27.1916 15.6472Z"
            fill="black"
          />
        </svg>
      </div>
    </TwitterShareButton>
    <LinkedinShareButton url={value}>
      <div className="btn-item">
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.5713 22.3822V28.5439H24.9997V22.7939C24.9997 21.3506 24.483 20.3656 23.1897 20.3656C22.203 20.3656 21.6147 21.0289 21.3563 21.6722C21.263 21.9022 21.238 22.2222 21.238 22.5422V28.5439H17.6647C17.6647 28.5439 17.713 18.8072 17.6647 17.7989H21.238V19.3206L21.2147 19.3556H21.238V19.3222C21.713 18.5889 22.5597 17.5456 24.458 17.5456C26.808 17.5456 28.5713 19.0822 28.5713 22.3822ZM13.9263 12.6172C12.7047 12.6172 11.9047 13.4205 11.9047 14.4739C11.9047 15.5072 12.6813 16.3322 13.8797 16.3322H13.903C15.1497 16.3322 15.9247 15.5055 15.9247 14.4739C15.9013 13.4205 15.1497 12.6172 13.9263 12.6172ZM12.1163 28.5439H15.6897V17.7989H12.1163V28.5439Z"
            fill="black"
          />
          <path
            d="M10.2381 7.16536C9.35403 7.16536 8.50618 7.51655 7.88106 8.14168C7.25593 8.7668 6.90474 9.61465 6.90474 10.4987V30.4987C6.90474 31.3827 7.25593 32.2305 7.88106 32.8557C8.50618 33.4809 9.35403 33.832 10.2381 33.832H30.2381C31.1221 33.832 31.9699 33.4809 32.5951 32.8557C33.2202 32.2305 33.5714 31.3827 33.5714 30.4987V10.4987C33.5714 9.61465 33.2202 8.7668 32.5951 8.14168C31.9699 7.51655 31.1221 7.16536 30.2381 7.16536H10.2381ZM10.2381 3.83203H30.2381C32.0062 3.83203 33.7019 4.53441 34.9521 5.78465C36.2024 7.0349 36.9047 8.73058 36.9047 10.4987V30.4987C36.9047 32.2669 36.2024 33.9625 34.9521 35.2127C33.7019 36.463 32.0062 37.1654 30.2381 37.1654H10.2381C8.46996 37.1654 6.77428 36.463 5.52403 35.2127C4.27379 33.9625 3.57141 32.2669 3.57141 30.4987V10.4987C3.57141 8.73058 4.27379 7.0349 5.52403 5.78465C6.77428 4.53441 8.46996 3.83203 10.2381 3.83203Z"
            fill="black"
          />
        </svg>
      </div>
    </LinkedinShareButton>
  </ButtonShareGroup>
);

export const ActionLinkComponent = ({ value }) => {
  const { T } = useApp();
  const copyRef = useRef();
  const [isOpenQR, setIsOpenQR] = useState(false);
  const handleCopy = () => {
    copyRef.current.click();
  };

  return (
    <div className="flex gap-3">
      <Button
        onClick={handleCopy}
        style={{ border: "1px solid rgba(0, 0, 0, 0.10)", background: "#fff" }}
        className="flex items-center gap-2 rounded-xl p-2 px-[6px] lg:px-4 text-[12px] lg:text-[16px]"
        icon={
          <Copy
            ref={copyRef}
            text={value}
            isShowText={false}
            icon={<CopyIcon2 />}
          />
        }
      >
        {T("Copy")}
      </Button>
      <div className="relative">
        <Popover
          overlayClassName="popupShare"
          placement="top"
          content={() => content(value)}
          trigger="click"
        >
          <Button
            style={{
              border: "1px solid rgba(0, 0, 0, 0.10)",
              background: "#fff",
            }}
            className="flex items-center gap-2 rounded-xl p-2  px-[6px] lg:px-4 text-[12px] lg:text-[16px]"
            icon={<ShareIcon />}
          >
            {T("Share")}
          </Button>
        </Popover>
      </div>
      <Button
        style={{ border: "1px solid rgba(0, 0, 0, 0.10)", background: "#fff" }}
        className="flex items-center gap-2 rounded-xl p-2  px-[6px] lg:px-4 text-[12px] lg:text-[16px]"
        icon={<QRIcon />}
        onClick={() => setIsOpenQR(true)}
      >
        {T("View QR code")}
      </Button>
      <Modal
        width={220}
        centered
        visible={isOpenQR}
        footer={null}
        onOk={() => setIsOpenQR(false)}
        onCancel={() => setIsOpenQR(false)}
      >
        <div className="flex justify-center p-6">
          <QRCode size={130} value={value || ""} />
        </div>
      </Modal>
    </div>
  );
};

export const ActionLinkComponent2 = ({ value }) => {
  const { T } = useApp();
  const copyRef = useRef();
  const [isOpenQR, setIsOpenQR] = useState(false);
  const svgRef = useRef(null);
  const handleCopy = () => {
    // copyRef.current.click();
  };

  const size = useWindowSize();

  const handleSaveImage = () => {
    return new Promise((resolve, reject) => {
      const svg = document.getElementById("QR-affiliate");
      if (svg) {
        const svgXml = new XMLSerializer().serializeToString(svg);
        const url = `data:image/svg+xml;base64,${btoa(svgXml)}`;

        const img = new Image();
        img.onload = function () {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = svg.width.baseVal.value;
          canvas.height = svg.height.baseVal.value;

          // Draw SVG onto the canvas
          context.drawImage(img, 0, 0);

          // Convert canvas to Data URL (PNG)
          const dataUrl = canvas.toDataURL("image/png");

          // Release the URL
          URL.revokeObjectURL(url);
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = "qr.png";
          link.click();
          resolve(dataUrl);
        };

        img.onerror = function (error) {
          // Release the URL
          URL.revokeObjectURL(url);

          // Reject with the error
          reject(error);
        };

        img.src = url;
      }
    });
  };

  return (
    <div>
      <div className="flex gap-2.5 lg:gap-5">
        <div onClick={handleCopy}>
          <Copy
            ref={copyRef}
            text={value}
            isShowText={false}
            icon={<CopyIcon2 />}
          />
        </div>
        <Popover
          overlayClassName="popupShare"
          placement="top"
          content={() => content(value)}
          trigger="click"
        >
          <div className="cursor-pointer">
            <ShareIcon />
          </div>
        </Popover>

        <div onClick={() => setIsOpenQR(true)}>
          <div className="cursor-pointer">
            <QRIcon />
          </div>
        </div>
      </div>

      <Modal
        width={size.width < 1024 ? 340 : 550}
        centered
        visible={isOpenQR}
        footer={null}
        onOk={() => setIsOpenQR(false)}
        onCancel={() => setIsOpenQR(false)}
        className="qr-affiliate"
      >
        <div className="flex flex-col pt-[40px] lg:pt-0 items-center justify-center">
          <QRCode
            ref={svgRef}
            id="QR-affiliate"
            size={size.width < 1024 ? 130 : 300}
            value={value || ""}
          />
          <div>
            <Textdetail
              style={{
                fontSize: size.width < 1024 ? "13px" : "16px",
                whiteSpace: size.width < 1024 ? "wrap" : "nowrap",
                marginTop: size.width < 1024 ? "24px" : "36px",
                display: "inline-block",
              }}
            >
              {T("Share this qr code on your social networks.")}
            </Textdetail>
          </div>
          <div
            className="flex flex-col items-center cursor-pointer"
            onClick={handleSaveImage}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 20C4 23.7712 4 25.6569 5.17157 26.8284C6.34315 28 8.22876 28 12 28H20C23.7712 28 25.6569 28 26.8284 26.8284C28 25.6569 28 23.7712 28 20"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.9998 3.9987V21.332M15.9998 21.332L21.3332 15.4987M15.9998 21.332L10.6665 15.4987"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>{T("Download")}</span>
          </div>
        </div>
      </Modal>
    </div>
  );
};
